import { render, staticRenderFns } from "./prizeModal.vue?vue&type=template&id=2502fdb3&scoped=true"
import script from "./prizeModal.vue?vue&type=script&lang=js"
export * from "./prizeModal.vue?vue&type=script&lang=js"
import style0 from "./prizeModal.vue?vue&type=style&index=0&id=2502fdb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2502fdb3",
  null
  
)

export default component.exports